import script from "./ChangeCategoryDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeCategoryDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeCategoryDrawer.vue?vue&type=style&index=0&id=ad77ab94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad77ab94"]])

export default __exports__